
namespace TabAurous.Finance {

    @Serenity.Decorators.registerClass()
    export class PDCClearanceDetailsGrid extends Serenity.EntityGrid<PDCClearanceDetailsRow, any> {
        protected getColumnsKey() { return 'Finance.PDCClearanceDetails'; }
        protected getDialogType() { return PDCClearanceDetailsDialog; }
        protected getIdProperty() { return PDCClearanceDetailsRow.idProperty; }
        protected getInsertPermission() { return PDCClearanceDetailsRow.insertPermission; }
        protected getLocalTextPrefix() { return PDCClearanceDetailsRow.localTextPrefix; }
        protected getService() { return PDCClearanceDetailsService.baseUrl; }

        constructor(container: JQuery) {
            super(container);
        }
    }
}